module.exports = __webpack_public_path__ + "img/slider.e9cd41d5.jpg";